export default __webpack_public_path__ + "images/src/assets/images/header/logo-white.png";